import { Axios } from 'utils'
import {
  FlourFilterPayload,
  TFlourCategory,
  TFlourWithId,
  TFlourWithoutCategories,
} from 'types/models/Flours'
import {
  ItemResponseType,
  ListPaginationParams,
  ListResponseType,
} from './types'
import { Delivery, TAttribute, TSpectralDistanceData } from '../types'

export const useFloursService = () => {
  const getFlourProducts = async (pagination?: ListPaginationParams) => {
    try {
      const response = await Axios.get<ListResponseType<TFlourWithId>>(
        '/flour/products',
        {
          params: pagination
            ? {
                offset: pagination.currentPage * pagination.itemsPerPage,
                limit: pagination.itemsPerPage,
              }
            : undefined,
        }
      )
      return response.data
    } catch (error: unknown) {
      throw error
    }
  }

  const getFlourAttributes = async () => {
    try {
      const response = await Axios.get<ListResponseType<TAttribute>>(
        '/flour/products/attributes'
      )
      return response.data
    } catch (error: unknown) {
      throw error
    }
  }

  const getFlourCategoriesWithAttributes = async () => {
    try {
      const response = await Axios.get<ListResponseType<TFlourCategory>>(
        '/flour/products/categories/attributes'
      )
      return response.data
    } catch (error: unknown) {
      throw error
    }
  }

  const createFlourProduct = async (params: TFlourWithoutCategories) => {
    try {
      const response = await Axios.post<
        ItemResponseType<TFlourWithoutCategories>
      >('/flour/products', params)
      return response.data
    } catch (error: unknown) {
      throw error
    }
  }

  const updateFlourProduct = async (params: TFlourWithoutCategories) => {
    try {
      const response = await Axios.put<
        ItemResponseType<TFlourWithoutCategories>
      >(`/flour/products/${params.id}`, params)
      return response.data
    } catch (error: unknown) {
      throw error
    }
  }

  const deleteFlourProduct = async (id: number) => {
    try {
      const response = await Axios.delete<{ status: boolean; detail: string }>(
        `/flour/products/${id}`
      )
      return response.data
    } catch (error: unknown) {
      throw error
    }
  }

  return {
    getFlourProducts,
    getFlourAttributes,
    getFlourCategoriesWithAttributes,
    createFlourProduct,
    updateFlourProduct,
    deleteFlourProduct,
  }
}
